import { Injectable } from "@angular/core";
import { BehaviorSubject, map, of, tap } from "rxjs";
import { permissions } from "../../utils/constants";
import { api } from "../../utils/endpoints";
import { CommonDataSharingService } from "./common-data-sharing.service";
import { ApiCallsService } from "./network/api-calls.service";

@Injectable({
  providedIn: "root",
})
export class AuthPermissionService {
  private _authPermission$ = new BehaviorSubject<any>(permissions);
  authPermisions = this._authPermission$.asObservable();

  authPermissionsList: any;
  constructor(
    private _apiCalls: ApiCallsService,
    private _commonDataService: CommonDataSharingService
  ) {}

  getAuthPermissions = () =>
    this.authPermissionsList
      ? of(this.authPermissionsList)
      : this._apiCalls.post(api._permissionsAuth, {}).pipe(
          tap((res) => {
            if (res) {
              const decryptResponse: any =
                this._commonDataService.JSONFormatter(res); // Decrypt API response
              this.authPermissionsList = decryptResponse?.data?.userPermissions;
              this._authPermission$.next(this.authPermissionsList);
            }
          }),
          map(() => this.authPermissionsList) // Ensure the transformed value is returned
        );

  clearPermissions() {
    this.authPermissionsList = [];
    this._authPermission$.next(permissions);
  }
}
